import modelsResolver from 'utils/api/models/utils/modelsResolver';
import { OfflinePaymentAttachment } from 'utils/api/models/billingPaymentTrack/offlinePaymentAttachment';

export enum OfflinePaymentStatus {
	NEW = 'NEW',
	RESOLVED = 'RESOLVED',
	IN_PROGRESS = 'IN_PROGRESS',
	REJECTED = 'REJECTED',
	DONE = 'DONE',
	ERROR = 'ERROR',
}

export type OfflinePayment = {
	_attachments: any;
	attachments: OfflinePaymentAttachment[];
	bankAccountNumber: string;
	bankCode: string;
	bankTransactionId: string;
	chequeNumber: string;
	customerType: string;
	invoiceType: string;
	approvalDate: string;
	paymentId: number;
	paymentStatus: string;
	paymentType: string;
	ticketExternalId: string;
	totalAmountPaid: number;
	trackingNumber: string;
	createdBy: number;
	statusDescription?: string;
};

const model: types.models.InputModel = {
	_attachments: ['attachments', []],
	attachments: (model: OfflinePayment) => {
		return model._attachments.map((attachment: any) => {
			return modelsResolver(attachment, 'offlinePaymentAttachment');
		});
	},
	bankAccountNumber: 'bankAccountNumber',
	bankCode: 'bankCode',
	bankTransactionId: 'bankTransactionId',
	chequeNumber: 'chequeNumber',
	customerType: 'customerType',
	invoiceType: 'paymentLevel',
	approvalDate: 'approvalDate',
	paymentId: 'paymentId',
	paymentStatus: 'paymentStatus',
	paymentType: 'paymentType',
	ticketExternalId: 'ticketExternalId',
	totalAmountPaid: 'totalAmountPaid',
	trackingNumber: 'trackingNumber',
	createdBy: 'createdBy',
	statusDescription: 'statusDescription',
};

export default model;
